// Konteksty przekazują swoje konfiguracje do `initContext` w `customConfig` pod kluczami BEZ
// prefiksu (`YOURCX_CONFIG`), a komponenty czytają je z `globalProperties` pod kluczami
// Z prefiksem (`$VUE_YOURCX_CONFIG`). Bez mostka te dwa zbiory nazw nigdy się nie spotykały:
// `context-init.js` przypisywał `$VUE_*` z wartości bazowej — i to PO pętli `customConfig`,
// więc konfiguracja kontekstu była podwójnie martwa. Objaw: ankieta YourCX uruchamiała się
// na kontekstach, które ją wyłączyły (`orangedoppayment`, `njumobile`, `demoshop`, …
// — 13 kontekstów).
//
// Scalanie, nie podmiana: konteksty podają tylko to, co zmieniają. `pkoleasing`, `planetpay`,
// `sprawdzaj` i `superpharm` mają `audit: { active: true }` BEZ `surveyId` i liczą na
// identyfikator z konfiguracji bazowej — podmiana całości wołałaby `window.yourcx('survey',
// undefined)`.
const isPlainObject = (value) => !!value && typeof value === 'object' && !Array.isArray(value)

/**
 * Scala konfigurację kontekstu na bazową. Klucze kontekstu wygrywają, obiekty są scalane
 * w głąb, wszystko pozostałe (wartości proste, tablice) jest nadpisywane w całości.
 * Nie mutuje żadnego z argumentów — konfiguracje kontekstów są modułowymi stałymi,
 * a część z nich jest dodatkowo `Object.freeze`-owana (`src/context/eos`).
 */
export const mergeContextConfig = (baseConfig, contextConfig) => {
  if (!isPlainObject(contextConfig)) {
    return baseConfig
  }
  if (!isPlainObject(baseConfig)) {
    return contextConfig
  }

  const merged = { ...baseConfig }

  Object.entries(contextConfig).forEach(([key, value]) => {
    merged[key] =
      isPlainObject(value) && isPlainObject(baseConfig[key]) ? mergeContextConfig(baseConfig[key], value) : value
  })

  return merged
}
